export function useStaleWhileRevalidate<T>() {
  const cached = ref<T>();

  function read(key: string) {
    if (!import.meta.client) return;
    try {
      const raw = localStorage.getItem(key);
      if (raw) cached.value = JSON.parse(raw) as T;
    } catch {
      cached.value = undefined;
    }
  }

  function write(key: string, value: T) {
    if (!import.meta.client) return;
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      /* quota dépassé ou storage désactivé */
    }
  }

  function clear(key: string) {
    if (!import.meta.client) return;
    try {
      localStorage.removeItem(key);
    } catch {
      /* ignore */
    }
  }

  return { cached, read, write, clear };
}
